export default "__VITE_ASSET__D5o_Vr5X__"